// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React, { useEffect, useRef, useState } from 'react';

import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Hotspot from '@cloudscape-design/components/hotspot';
import Input, { InputProps } from '@cloudscape-design/components/input';
import Link from '@cloudscape-design/components/link';
import Checkbox from "@cloudscape-design/components/checkbox";
import ExpandableSection from "@cloudscape-design/components/expandable-section";


import Select, { SelectProps } from '@cloudscape-design/components/select';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
//import { useStore } from '../../store';
import Flashbar, { FlashbarProps } from '@cloudscape-design/components/flashbar';
import Grid from '@cloudscape-design/components/grid';
import { useGlobalState } from '../../../context/GlobalStateContext'
import { Badge, Box, DatePicker } from '@cloudscape-design/components';
import { format } from 'date-fns';

import { isValidPhone, storeJWT } from '../../../commons/functions'; // Import the function
import Icon from '@mdi/react';
import { mdiAlertBox, mdiCheckCircle, mdiLock } from '@mdi/js';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import DatePickerModal from '../../../../components/DatePickerModal';

export const UsersAddPage = () => {
  const storeAdmin = useStoreAdmin();
  const { idPropiedad } = useGlobalState();
  const { propiedad, setPropiedad } = useGlobalState();
  const { JWT, setJWT } = useGlobalState();
  const { idControl, setIdControl } = useGlobalState();

  interface AccessOption {
    value: string;
    label: string;
    description: string;
    disabled: boolean;
    idAcceso: string;
    idAutorizado: string;
    fechaAutorizacion: string;
    idSector: number;
  }

  interface policyOption {
    value: string;
    label: string;
    description: string;
    disabled: boolean;
    idAcceso: string;
    userPolicy: number;
  }
  interface exclusionOption {
    value: string;
    label: string;
    description: string;
    disabled: boolean;
    idAcceso: string;
    userExclusion: number;
  }

  interface Sector {
    idSector: number;
    sector: string;
  }
  const [jobName, setJobName] = useState('');
  const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);

  const [accessOptions, setAccessOptions] = useState<AccessOption[]>([]);
  const [policyOptions, setPolicyOptions] = useState<policyOption[]>([]);
  const [exclusionOptions, setExclusionOptions] = useState<exclusionOption[]>([]);
  const [sectors, setSectors] = useState<Sector[]>([]);

  const [selectedAccesses, setSelectedAccesses] = useState<string[]>([]);
  const [selectedPolicies, setSelectedPolicies] = useState<string[]>([]);
  const [selectedExclusions, setSelectedExclusions] = useState<string[]>([]);
  const [selectedUnidad, setSelectedUnidad] = useState<{ label: string, value: string } | null>(null);
  const [isDisabledNombre, setIsDisabledNombre] = useState(false);
  const [isDisabledApellido, setIsDisabledApellido] = useState(false);
  const [isDisabledEmail, setIsDisabledEmail] = useState(false);
  const [isDisabledMovil, setIsDisabledMovil] = useState(false);
  const [isDisabledUnidad, setIsDisabledUnidad] = useState(false);
  const [isDisabledBtnNext, setIsDisabledBtnNext] = useState(true);
  const [btnUserInfoVisible, setBtnUserInfoVisible] = useState(false);

  const [modalDateStartOpen, setModalDateStartOpen] = useState(false);
  const [modalDateStart, setModalDateStart] = useState('');
  const [modalDateEndOpen, setModalDateEndOpen] = useState(false);
  const [modalEndStart, setModalDateEnd] = useState('');

  const [defaultRegion] = useState(null);

  const [countPolicies, setCountPolicies] = React.useState("");
  const [countExclusions, setCountExclusions] = React.useState("");
  const [dateStartAutorizado, setDateStartAutorizado] = React.useState("");
  const [dateEndAutorizado, setDateEndAutorizado] = React.useState("");
  const [reqInfoTitle, setReqInfoTitle] = React.useState("");
  const [reqInfo, setReqInfo] = React.useState("");
  const [reqInfoUnidad, setReqInfoUnidad] = React.useState(0);
  const { setLoading } = useGlobalState();
  const inputRefMovil = useRef<HTMLInputElement>(null);
  /*
    const onJobNameChangePhone = (event: any) => {
      setJobName(event.detail.value);
      setMessages([]);
    };
    */
  const handleNumericInputChange: InputProps["onChange"] = (event) => {
    const digitsOnly = event.detail.value.replace(/\D/g, '');
    setInputMovil(digitsOnly);
    setJobName(event.detail.value);
    setMessages([]);
    setIsDisabledBtnNext(!isValidPhone(digitsOnly)); // Initially disable the button

  };

  const handleCheckboxChangeAccess = (value: string) => (event: { detail: { checked: boolean } }) => {
    setMessages([]);
    const checked = event.detail.checked;
    const value2 = parseInt(value)
    setSelectedAccesses(prevSelectedAccesses => {
      if (checked) {
        return [...prevSelectedAccesses, value];
      } else {
        return prevSelectedAccesses.filter(item => item !== value);
      }
    });
  };

  const handleCheckboxChangePolicy = (value: string) => (event: { detail: { checked: boolean } }) => {
    setMessages([]);
    const checked = event.detail.checked;
    setSelectedPolicies(prevSelectedAccesses => {
      if (checked) {
        return [...prevSelectedAccesses, value];
      } else {
        return prevSelectedAccesses.filter(item => item !== value);
      }
    });
  };
  const handleCheckboxChangeExclusion = (value: string) => (event: { detail: { checked: boolean } }) => {
    setMessages([]);
    const checked = event.detail.checked;
    setSelectedExclusions(prevSelectedAccesses => {
      if (checked) {
        return [...prevSelectedAccesses, value];
      } else {
        return prevSelectedAccesses.filter(item => item !== value);
      }
    });
  };


  const handleValidatePhone = async () => {
    const regex = /^\+?56\d{9}$/;
    if (!regex.test(inputMovil)) {
      setMessages([
        {
          type: 'error',
          content: 'Número inválido. Use formato +56912345678 o 56912345678',
          id: 'error-msg',
        },
      ]);
      return
    }
    const digitsOnly = inputMovil.replace(/\D/g, '');

    setIsDisabledMovil(true);

    setPendingJobCreation(true);
    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/users/preregister',
          'JWT': JWT,

        },
        body: JSON.stringify({
          movil: digitsOnly,
        }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
        setIsDisabledMovil(false);
      }
      const data = await response.json();

      storeAdmin(data);
      if (data.user.property.units && data.user.property.units.length > 0) {
        setShowExclusions(data.user.property.security.exclusions.length > 0);
        setShowExclusions(data.user.property.security.exclusions.length > 0);
        setShowPolicies(data.user.property.security.policies.length > 0);
        const unitOptions = (data?.user?.property?.units || []).map((unit: { idUnidad: number; unidad: string, reqInfoTitle: string, reqInfoUnidad: number }) => ({
          label: unit.unidad,
          reqInfoUnidad: unit.reqInfoUnidad,
          reqInfoTitle: unit.reqInfoTitle,
          value: unit.idUnidad.toString(),
        }));
        setSelectedUnit(null);
        setDateStartAutorizado("")
        setDateEndAutorizado("")
        setUnits(unitOptions);
        setShowForm2(1); // Show the form
        const options = data.user.property.accesses.map((access: any) => ({
          idSector: access.idSector,
          value: access.idAcceso.toString(),
          label: (
            <>
              {access.acceso}{' '}
              {access.idAutorizado > 0 ? (
                access.fechaAutorizacion === '' ? (
                  <>
                    <Badge color="severity-low"><Icon path={mdiAlertBox} color="white" size={0.5} />
                      Acceso se encuentra pendiente de autorización</Badge>{' '}
                  </>
                ) : (
                  <>

                    <Badge color="blue"><Icon path={mdiCheckCircle} color="white" size={0.5} /> Acceso ya registrado</Badge>{' '}
                  </>
                )
              ) : null}
              {access.relay === 0 ? (<Badge color="severity-low">*Virtual</Badge>) : null}
            </>
          ),

          disabled: access.idAutorizado > 0,
          idAcceso: access.idAcceso.toString(),
          idAutorizado: access.idAutorizado.toString(),
          fechaAutorizacion: access.fechaAutorizacion.toString(),
        }));
        setSectors(data.user.property.sectors)
        setAccessOptions(options)
        type AccessItem = {
          idAcceso: string;
          idAutorizado: string; // or number, adjust if needed
          fechaAutorizacion: string; // or number, adjust if needed
        };
        const fetchedValues = (data.user.property.accesses as AccessItem[])
          .filter((item: AccessItem) => Number(item.idAutorizado) > 0)
          .map((item: AccessItem) => item.idAcceso.toString());
        setSelectedAccesses(fetchedValues);

        const optionsPolicies = data.user.property.security.policies.map((policy: any) => ({
          value: policy.idPolicy.toString(),
          label: policy.policy,
          userPolicy: policy.userPolicy,
        }));
        const selectedPolicyIds = data.user.property.security.policies
          .filter((policy: any) => policy.userPolicy > 0)
          .map((policy: any) => policy.idPolicy.toString());
        setSelectedPolicies(selectedPolicyIds)
        console.log(selectedPolicyIds)
        setPolicyOptions(optionsPolicies)
        //
        const optionsExclusions = data.user.property.security.exclusions.map((exclusion: any) => ({
          value: exclusion.idExclusion.toString(),
          label: exclusion.exclusion,
          userExclusion: exclusion.userExclusion,
        }));
        setExclusionOptions(optionsExclusions)

        if (data.user.property.idUnidad > 0) {
          setIdUnidad(data.user.property.idUnidad);
          setReqInfoTitle(data.user.property.reqInfoTitle);
          setReqInfoUnidad(data.user.property.reqInfoUnidad);
          setReqInfo(data.user.property.reqInfo);
          const unidadFromAPI = data.user.property.idUnidad;
          type UnitOption = {
            label: string;
            value: string;
          };
          const matchedOption = unitOptions.find((option: UnitOption) => parseInt(option.value) === unidadFromAPI);
          if (matchedOption) {
            setSelectedUnit(matchedOption);
            setIsDisabledUnidad(true);

          }
        } else {
          setIdUnidad(0)
          setIsDisabledUnidad(false);
          setReqInfo("")
          setReqInfoTitle("")
          setReqInfoUnidad(0)
        }
        if (data.user) {
          // Set the input values if the data exists
          setInputNombre(data.user.nombre || '');  // If the field is not empty, set the value
          setInputApellido(data.user.apellido || '');
          setInputEmail(data.user.email || '');

          // If any field is populated, disable the inputs

          setIsDisabledNombre(data.user.nombre ? true : false)
          setIsDisabledApellido(data.user.apellido ? true : false)
          setIsDisabledEmail(data.user.email ? true : false)

          if (data.user.nombre !== '' && data.user.apellido !== '' && data.user.email !== '') {
            setInfoUserComplete(true)
            setBtnUserInfoVisible(false)
          } else {
            setInfoUserComplete(false)
            setBtnUserInfoVisible(true)

          }
        }

      } else {
        setShowForm2(-1);
        setIdUnidad(0)
        setIsDisabledMovil(false);
      }
    } catch (error: any) {
      setMessages([
        {
          type: 'error',
          content: `Error al contactar el servidor: ${error.message}`,
          id: 'server-error',
        },
      ]);
      setIsDisabledMovil(false);
    } finally {
      setPendingJobCreation(false);
      setLoading(false)

    }
  };
  /*
    const {
      actions: { makeHelpPanelHandler },
    } = useStore();
     */
  const { navigate } = useRouter();
  const [pendingJobCreation, setPendingJobCreation] = useState(false);
  const createJob = () => {
    //setPendingJobCreation(true);
    //setTimeout(() => navigate('transcription-job-list'), 1000);
  };

  const [showForm2, setShowForm2] = useState(-1);
  const [idUnidad, setIdUnidad] = useState(0);
  const [showPolicies, setShowPolicies] = useState(false);
  const [showExclusions, setShowExclusions] = useState(false);
  const [units, setUnits] = useState([]); // holds array of unit options
  const [selectedUnit, setSelectedUnit] = useState<SelectProps.Option | null>(null);

  /*
  const onJobNameChange = useCallback<InputChangeCallback>(event => setJobName(event.detail.value), []);
  const onOutputSettingChange = useCallback<InputChangeCallback>(event => setOutputSetting(event.detail.value), []);
  const onS3BucketChange = useCallback<OptionChangeCallback>(event => setS3Bucket(event.detail.selectedOption), []);
  */
  const onUnitChange = (event: { detail: SelectProps.ChangeDetail }) => {
    setMessages([]);
    setSelectedUnit(event.detail.selectedOption);

    type CustomOption = {
      label: string;
      value: string;
      reqInfoUnidad: number;
      reqInfoTitle: string;
    };
    const selected = event.detail.selectedOption as CustomOption;

    const value = event.detail.selectedOption?.value ?? "0";
    setIdUnidad(parseInt(value));
    setReqInfoTitle(selected.reqInfoTitle)
    setReqInfoUnidad(selected.reqInfoUnidad)

  };
  const handleCancelBtn = () => {
    setIsDisabledMovil(false);
    setShowForm2(-1);
    setInputMovil('');
    setIsDisabledBtnNext(true)
  };

  const handleDateChangeDateStartAutorizado = ({ detail }: any) => {
    setMessages([]);
    const formattedDate = format(new Date(detail.value), 'dd-MM-yyyy'); // Format the date
    setDateStartAutorizado(formattedDate);
  };

  const handleDateChangeDateEndAutorizado = ({ detail }: any) => {
    setMessages([]);
    const formattedDate = format(new Date(detail.value), 'dd-MM-yyyy'); // Format the date
    setDateEndAutorizado(formattedDate);
  };
  const [inputNombre, setInputNombre] = useState('');
  const [inputApellido, setInputApellido] = useState('');
  const [inputEmail, setInputEmail] = useState('');
  //const [inputMovil, setInputMovil] = useState('56975945401');
  const [inputMovil, setInputMovil] = useState('');
  //const [inputMovil, setInputMovil] = useState('56991296532');
  const [checked, setChecked] = React.useState(false);
  const [infoUserComplete, setInfoUserComplete] = React.useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRefMovil.current) {
        inputRefMovil.current.focus();
      }
    }, 500); // 2000 milliseconds = 2 seconds

    // Cleanup if component unmounts
    return () => clearTimeout(timer);
  }, []);

  const handleBtnInfoUser = async () => {
    try {
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/users/preregister',
          'JWT': JWT,

        },
        body: JSON.stringify({
          movil: inputMovil,
          nombre: inputNombre,
          apellido: inputApellido,
          email: inputEmail,
        }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
        setIsDisabledMovil(false);
      }
      const data = await response.json();

      storeAdmin(data);
      if (data.code === 0) {
        handleValidatePhone()
      }


    } catch (error: any) {
      setMessages([
        {
          type: 'error',
          content: `Error al contactar el servidor: ${error.message}`,
          id: 'server-error',
        },
      ]);
    } finally {
      setPendingJobCreation(false);

    }
    if (inputNombre === '' || inputApellido === '' || inputEmail === '') {
      return;
    }
    else if (inputEmail !== '')//} && !isEmail(inputEmail))
    {
      return;
    }
  };

  const handleBtnRegisterUser = async () => {

    const objAccesses = selectedAccesses.map(id => ({ idAcceso: id }));
    const objPolicies = selectedPolicies.map(id => ({ idPolicy: id }));
    const Exclusions = selectedExclusions.map(id => ({ idExclusion: id }));
    const body = {
      movil: inputMovil,
      accesses: objAccesses,
      idUnidad: idUnidad,
      policies: objPolicies,
      exclusions: Exclusions,
      dateStartAutorizado: dateStartAutorizado,
      dateEndAutorizado: dateEndAutorizado,
      auth: true,
      //reqIn:dateStartAutorizado,
    }
    if (idUnidad === 0) {
      setMessages([
        {
          type: 'error',
          content: `Debe seleccionar la unidad asociada al usuario`,
          id: 'server-error',
        },
      ]);
      return
    }
    if (reqInfo === "" && reqInfoUnidad === 1) {
      setMessages([
        {
          type: 'error',
          content: (
            <>
              Debe contestar la pregunta: <strong>{reqInfoTitle}</strong>
            </>
          ),
          id: 'server-error',
        },
      ]);
      return
    }

    console.log(selectedAccesses)
    if (selectedAccesses.length === 0) {
      setMessages([
        {
          type: 'error',
          content: `Debe seleccionar al menos un acceso`,
          id: 'server-error',
        },
      ]);
      return
    }
    console.log(body)
    try {
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/users/add',
          'JWT': JWT,

        },
        body: JSON.stringify(body),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
        setIsDisabledMovil(false);
      }
      const data = await response.json();

      storeAdmin(data);
      if (data.code === 0) {
        window.location.href = "#users/list"
      }


    } catch (error: any) {
      setMessages([
        {
          type: 'error',
          content: `Error al contactar el servidor: ${error.message}`,
          id: 'server-error',
        },
      ]);
    } finally {
      setPendingJobCreation(false);

    }
    /*
    if (inputNombre === '' || inputApellido === '' || inputEmail === '') {
      return;
    }
    else if (inputEmail !== '')//} && !isEmail(inputEmail))
    {
      return;
    }
    */
  };
  return (
    <CustomAppLayout
      //title={propiedad}

      toolsHide={true}
      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: 'Inicio', href: '#home' },
            { text: 'Usuarios', href: '#users' },
            { text: 'Agregar usuario', href: '#create-transcription-job' },
          ]}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>

          <Form
            header={
              <Header
                variant="h2"
              >
                Agregar nuevo usuario y accesos
              </Header>
            }

            actions={

              <SpaceBetween direction="horizontal" size="xs">

                {showForm2 >= 0 && infoUserComplete && (
                  <Button variant="link" disabled={pendingJobCreation} onClick={handleCancelBtn}>
                    Cancelar
                  </Button>
                )}

                {showForm2 >= 0 && infoUserComplete && (
                  <Button variant="primary" loading={pendingJobCreation} onClick={handleBtnRegisterUser} ariaLabel="Create job">
                    Asignar Accesos
                  </Button>
                )}
              </SpaceBetween>
            }
          >
            <SpaceBetween size="xl">
              <Container header={<Header variant="h3">Identificación del usuario</Header>}>
                <SpaceBetween size="l">
                  <Flashbar items={messages} />
                  <FormField
                    label="Número de móvil"
                    constraintText="El número de móvil debe ser en formato internacional (Ej: +56912345678)."
                    info={
                      <Link
                        variant="info"

                        ref={inputRefMovil}
                        //onFollow={makeHelpPanelHandler('name')}
                        ariaLabel="Sintaxis del móvil."
                      >
                        Info
                      </Link>
                    }
                  >
                    <Hotspot hotspotId="transcription-job-name">
                      <SpaceBetween direction="horizontal" size="xs">
                        <Input
                          controlId='infoMovil'
                          value={inputMovil}
                          placeholder="56912354678"
                          disabled={isDisabledMovil}
                          onChange={handleNumericInputChange}

                          autoFocus
                          autoComplete="new-password"

                          onKeyDown={(e) => {
                            if (e.detail.key === 'Enter' && isValidPhone(inputMovil.replace(/\D/g, ''))) {
                              handleValidatePhone()
                            }
                          }}
                        />
                        {showForm2 === -1 && (
                          <Button onClick={handleValidatePhone} disabled={isDisabledBtnNext} variant="primary" loading={pendingJobCreation} >Siguiente</Button>
                        )}
                        {showForm2 >= 0 && (
                          <Button onClick={handleCancelBtn} variant='normal'>Cancelar</Button>
                        )}
                      </SpaceBetween>
                    </Hotspot>
                  </FormField>
                  {showForm2 >= 0 && (
                    <FormField label="Información del Usuario" description="En caso de que un campo se encuentre vacío, deberá ser completado">
                      {/* Row 1 */}

                      <Grid gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}>
                        <Input
                          controlId='infoNombre'
                          value={inputNombre}
                          onChange={(e) => setInputNombre(e.detail.value.toUpperCase())}
                          placeholder="Nombre"
                          readOnly={isDisabledNombre}
                        />
                        <Input
                          controlId='infoApellido'
                          value={inputApellido}
                          onChange={(e) => setInputApellido(e.detail.value.toUpperCase())}
                          placeholder="Apellido"
                          readOnly={isDisabledApellido}
                        />
                      </Grid>

                      {/* Row 2 */}
                      <Grid gridDefinition={[{ colspan: 12 }]}>
                        <Input
                          controlId='infoEmail'
                          value={inputEmail}
                          onChange={(e) => setInputEmail(e.detail.value.toLowerCase())}
                          placeholder="Email"
                          readOnly={isDisabledEmail}
                        />
                      </Grid>

                      {/* Row 2 */}
                      <Grid gridDefinition={[{ colspan: 12 }]}>

                        <Box textAlign='right' display={btnUserInfoVisible ? 'block' : 'none'}><Button variant='primary'
                          onClick={handleBtnInfoUser}
                        >Siguiente</Button></Box>
                      </Grid>


                    </FormField>
                  )}
                </SpaceBetween>
              </Container>
              {showForm2 >= 0 && infoUserComplete && (
                <Container header={<Header variant='h3'>Accesos y Seguridad</Header>}>
                  <SpaceBetween direction='horizontal' size='xs'>
                    <FormField label={`Unidad a asignar`}
                      description={
                        idUnidad > 0 ? (
                          <span>
                            Usuario ya se encuentra asignado a la unidad{' '}
                            <Icon path={mdiLock} size={0.75} color="orange" />
                          </span>
                        ) : (
                          "Seleccione la unidad a la cual el usuario será asignado."
                        )
                      }
                    >
                      <Hotspot hotspotId="language-selector">
                        <Select
                          filteringType="auto"
                          selectedOption={selectedUnit} //{units.find(opt => opt.value === idUnidad)}
                          onChange={onUnitChange}
                          options={units}
                          controlId='infoIdUnidad'
                          readOnly={isDisabledUnidad}
                        />
                      </Hotspot>
                    </FormField>
                  </SpaceBetween>
                  {reqInfoUnidad > 0 && (
                    <FormField
                      label={reqInfoTitle}
                      constraintText="Pregunta obligaria solicitada por la administración."
                    >
                      <Input
                        controlId='reqInfoUnidad'
                        value={reqInfo}
                        onChange={(e) => { setReqInfo(e.detail.value); setMessages([]) }}
                        placeholder=""
                      />
                    </FormField>
                  )}
                  <FormField>

                    <ExpandableSection headerText={`Accesos (${selectedAccesses.length}/${accessOptions.length})`} defaultExpanded>
                      <SpaceBetween direction="vertical" size="xs">
                        {sectors.map(optionSector => (
                          <div key={optionSector.sector}>
                            <FormField
                              label={`Sector ${optionSector.sector == "*" ? "General" : optionSector.sector}`}
                            >
                              <SpaceBetween direction='vertical' size='xs'>
                                {accessOptions
                                  .filter(option => option.idSector === optionSector.idSector)
                                  .map(option => (
                                    <Checkbox
                                      controlId='InfoIdAcceso'
                                      key={`${optionSector.sector}-${option.value}`} // Unique key
                                      checked={selectedAccesses.includes(option.value)}
                                      onChange={handleCheckboxChangeAccess(option.value)}
                                      readOnly={option.disabled}
                                    >
                                      <label>
                                        {option.label}

                                        {/* Optional description */}
                                        {/* <div>{option.description}</div> */}
                                      </label>
                                    </Checkbox>
                                  ))}
                              </SpaceBetween>
                            </FormField>
                          </div>
                        ))}
                      </SpaceBetween>
                    </ExpandableSection>
                    {showPolicies && (
                      <ExpandableSection headerText={`Políticas de Seguridad (${selectedPolicies.length}/${policyOptions.length})`}>
                        <SpaceBetween direction="vertical" size="xs">
                          {policyOptions.map(option => (
                            <Checkbox
                              controlId='InfoIdPolicy'
                              key={`pol${option.value}`}
                              checked={selectedPolicies.includes(option.value)}
                              onChange={handleCheckboxChangePolicy(option.value)}
                            >
                              {option.label}
                            </Checkbox>
                          ))}
                        </SpaceBetween>

                      </ExpandableSection>
                    )}
                    {showExclusions && (
                      <ExpandableSection headerText={`Exclusiones de Seguridad (${selectedExclusions.length}/${exclusionOptions.length})`}>

                        <SpaceBetween direction="vertical" size="xs">
                          {exclusionOptions.map(option => (
                            <Checkbox
                              controlId='InfoIdExclusion'
                              key={`exc${option.value}`}
                              checked={selectedExclusions.includes(option.value)}
                              onChange={handleCheckboxChangeExclusion(option.value)}
                            >
                              {option.label}
                            </Checkbox>
                          ))}
                        </SpaceBetween>
                      </ExpandableSection>
                    )}
                    <h3>Fechas de inicio y término (opcionales)</h3>
                    <SpaceBetween direction="horizontal" size="xs">
                      <FormField label="Autorizar desde">
                        <SpaceBetween direction="horizontal" size="xs">
                          <Input
                            value={dateStartAutorizado}
                            readOnly
                            placeholder="Inicio"
                          />
                          <Button
                            iconName="calendar"
                            onClick={() => setModalDateStartOpen(true)}
                          />
                        </SpaceBetween>
                      </FormField>

                      <FormField label="Autorizar hasta">
                        <SpaceBetween direction="horizontal" size="xs">
                          <Input
                            value={dateEndAutorizado}
                            readOnly
                            placeholder="Término"
                          />
                          <Button
                            iconName="calendar"
                            onClick={() => setModalDateEndOpen(true)}
                          />
                        </SpaceBetween>
                      </FormField>

                    </SpaceBetween>
                  </FormField>
                </Container>
              )}
            </SpaceBetween>
          </Form>


          <DatePickerModal
            visible={modalDateStartOpen}
            clear={true}
            close={true}
            start={new Date}
            title='Seleccione'
            subTitle='Inicio de autorización'
            onDismiss={() => {
              setModalDateStartOpen(false)
            }}
            onConfirm={(date) => {
              setModalDateStartOpen(false);
              setDateStartAutorizado(date)
            }}
          />
          <DatePickerModal
            visible={modalDateEndOpen}
            clear={true}
            close={true}
            start={new Date}
            title='Seleccione'
            subTitle='Término de autorización'
            onDismiss={() => {
              setModalDateEndOpen(false)
            }}
            onConfirm={(date) => {
              setModalDateEndOpen(false);
              setDateEndAutorizado(date)
            }}
          />
        </>
      }
    />
  );
};
